<template>
  <div>
    <!--登入成功-->
    <div v-if="noticeMessage" class="popup-wrap" :class="{ active: noticeMessage }">
      <div class="popup-box mx-395">
        <a v-if="noticeMessage.close !== 'removeClose'" class="popup-close" @click="hideModal"><i class="fa-solid fa-xmark" /></a>
        <div class="form-popup popup-padding popup-default">
          <div class="popup-envelop">
            <div class="content content-center">
              <!-- eslint-disable-next-line -->
              <p v-if="isHtml" class="text-center" v-html="message" />
              <p v-else class="text-center">
                {{ message }}
              </p>
            </div>
            <div class="form-button form-ft">
              <template v-if="noticeMessage">
                <template v-if="noticeMessage.close === 'callAPI'">
                  <button class="btn-primary goTo-fun-popup-game-infor" @click="submit">
                    <span>YES</span>
                  </button>
                  <button class="btn-primary goTo-fun-popup-game-infor" @click="hideModal">
                    <span>NO</span>
                  </button>
                </template>
                <button v-else class="btn-primary goTo-fun-popup-game-infor" @click="submit">
                  <span>{{ submitLabel }}</span>
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notice',
  data() {
    return {
      isHtml: false
    }
  },
  computed: {
    noticeMessage() {
      return this.$store.getters.noticeMessage
    },
    message() {
      if (!this.noticeMessage) {
        return null
      }

      return this.$te(this.noticeMessage.message) ? this.$t(this.noticeMessage.message) : this.noticeMessage.message
    },
    submitLabel() {
      const isUseOKText = this.noticeMessage.isUseOKText
      if (isUseOKText) {
        return isUseOKText
      } else {
        return this.$te('Bao.submit') ? this.$t('Bao.submit') : 'OK'
      }
    }
  },
  watch: {
    message(newVal, oldVal) {
      if (newVal === 'closeModal') {
        this.hideModal()
      } else if (newVal != null) {
        if (this.message.indexOf('<') > -1) {
          this.isHtml = true
        } else {
          this.isHtml = false
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    hideModal() {
      const pathSegments = window.location.pathname.split('/').filter(segment => segment !== '')
      const firstSegment = pathSegments[0]

      this.$store.commit('SET_NOTICE_MESSAGE', null)
      if (firstSegment === 'campaign') {
        this.$router.push('/').then(() => {
          window.location.reload()
        })
      }
    },
    submit() {
      const func = this.noticeMessage.func
      const close = this.noticeMessage.close
      const msg = this.noticeMessage.message
      if (msg === this.$t('Bao.free_spin_double_check') && close) {
        this.$store.commit('SET_CONFIRM_PURCHASE', true)
      }

      if (close) {
        this.hideModal()
        if (close === 'callAPI') {
          this.$store.commit('SET_API_EXECUTE', true)
        }
      }
      if (func !== undefined && typeof func === 'function') {
        func()
      }
    }
  }
}
</script>
